import { render, staticRenderFns } from "./CustomConfirmDialog.vue?vue&type=template&id=5dec5757&scoped=true"
import script from "./CustomConfirmDialog.vue?vue&type=script&lang=js"
export * from "./CustomConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomConfirmDialog.vue?vue&type=style&index=0&id=5dec5757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec5757",
  null
  
)

export default component.exports